/**
 * Map KB items / matched activities to routine slot categories.
 */

export function inferRoutineSlotCategories(kbItem) {
  if (kbItem.routineSlotCategories?.length) {
    return kbItem.routineSlotCategories;
  }

  const title = (kbItem.title || '').toLowerCase();
  const tags = (kbItem.tags || []).map((t) => t.toLowerCase());
  const domains = (kbItem.targetDomains || []).map((d) => d.toLowerCase());
  const categories = new Set();

  const add = (c) => categories.add(c);

  if (
    title.includes('pecs') ||
    title.includes('symbol exchange') ||
    title.includes('aac') ||
    tags.some((t) => ['aac', 'pecs', 'requesting', 'symbol'].some((k) => t.includes(k)))
  ) {
    add('snack_communication');
    add('morning_literacy');
  }
  if (title.includes('makaton') || tags.includes('signing')) {
    add('registration');
    add('snack_communication');
  }
  if (title.includes('bucket') || title.includes('attention autism')) {
    add('bucket_time');
  }
  if (title.includes('intensive interaction') || tags.includes('intensive-interaction')) {
    add('intensive_interaction');
    add('arrival_free_flow');
  }
  if (title.includes('cause') || title.includes('effect') || tags.includes('cause-effect')) {
    add('cause_effect_play');
    add('arrival_free_flow');
  }
  if (title.includes('sensory') || title.includes('circuit') || domains.includes('sensory') || tags.includes('sensory')) {
    add('afternoon_sensory');
  }
  if (title.includes('story') || title.includes('calm')) {
    add('story_calm');
  }
  if (title.includes('visual schedule') || title.includes('now and next') || tags.includes('routine')) {
    add('registration');
    add('end_of_day');
  }
  if (title.includes('phonics') || title.includes('literacy') || title.includes('reading') || domains.includes('literacy') || domains.includes('communication')) {
    add('morning_literacy');
  }
  if (title.includes('numeracy') || title.includes('math') || title.includes('counting') || domains.includes('cognition')) {
    add('early_numeracy');
  }
  if (title.includes('free flow') || title.includes('exploration')) {
    add('arrival_free_flow');
  }
  if (title.includes('welcome') || title.includes('registration')) {
    add('registration');
  }
  if (title.includes('end of day') || title.includes('home time')) {
    add('end_of_day');
  }
  if (title.includes('snack') || title.includes('meal')) {
    add('snack_communication');
  }
  if (title.includes('intervention') || title.includes('therapy') || title.includes('salt') || title.includes('ot ')) {
    add('focused_intervention');
  }

  if (categories.size === 0) {
    if (domains.includes('communication')) add('morning_literacy');
    else if (domains.includes('sensory')) add('afternoon_sensory');
    else add('focused_intervention');
  }

  return [...categories];
}
